<template>
<div>

 <div class="contactform container">
  <form action="" name="theformTwo" class="form">

    <section class="form-group">
      <label class="labelName" for="">Met wie hebben we het genoegen?</label><br>
      <input class="name" type="text" v-on:keyup="checkform" name="name" id="name" @click="checkInputName" @blur="checkInputName" @keydown="checkInputName" autocomplete="off" v-model="$v.formResponses.name.$model" />
      <p v-if="errors" class="error">
      <span v-if="!$v.formResponses.name.required">Dit veld is verplicht.</span>
      <span
        v-if="!$v.formResponses.name.minLength"
      >Op zijn minst {{ $v.formResponses.name.$params.minLength.min }} karakters invoeren.</span>
      </p> 
    </section>

      <section class="form-group">
      <label class="labelNumber" for="">Telefoonnummer</label><br>
      <input class="number" type="tel" v-on:keyup="checkform" name="number" id="number" @click="checkInputNumber" @blur="checkInputNumber" @keydown="checkInputNumber" autocomplete="off" v-model="$v.formResponses.number.$model">
      <p v-if="errors" class="error">
      <span v-if="!$v.formResponses.number.required">Dit veld is verplicht.</span>
      <span
        v-if="!$v.formResponses.number.minLength"
      >Op zijn minst {{ $v.formResponses.number.$params.minLength.min }} karakters invoeren.</span>
      </p> 
    </section>

    <section class="form-group">
      <label class="labelEmail" for="">Wat is je e-mailadres</label><br>
      <input class="email" type="tekst" v-on:keyup="checkform" name="email" id="email" autocomplete="off" @click="checkInputEmail" @blur="checkInputEmail" @keydown="checkInputEmail" v-model="$v.formResponses.email.$model">
      <p v-if="errors" class="error">
      <span v-if="!$v.formResponses.email.required">Dit veld is verplicht.</span>
      <span v-if="!$v.formResponses.email.email">Dit moet een e-mailadres zijn</span>
      </p>
    </section>

    <section class="form-group">
      <label class="labelProject" for="">Vertel ons iets over je project of jezelf</label><br>
      <textarea class="project" type="text" v-on:keyup="checkform" name="project" id="project" @click="checkInputProject" @blur="checkInputProject" @keydown="checkInputProject" autocomplete="off" v-model="$v.formResponses.project.$model"></textarea>
      <p v-if="errors" class="error">
      <span v-if="!$v.formResponses.project.required">Dit veld is verplicht.</span>
      <span
        v-if="!$v.formResponses.project.minLength"
      >Op zijn minst {{ $v.formResponses.project.$params.minLength.min }} karakters invoeren.</span>
      </p> 
    </section>

    <section class="checkbox-group">
    <input 
      type="checkbox" 
      name="checkbox" 
      id="checkbox" 
      v-model="formResponses.checkbox"
    >
    <label>Ik ga akkoord met de <router-link class="router-link" to="/privacy-verklaring"> privacy voorwaarden </router-link> van Folded Paper</label>
    <p>
      <span
        v-if="!$v.formResponses.checkbox.sameAs && $v.formResponses.checkbox.$error"
      >De checkbox is verplicht</span>
    </p> 
    </section>

    <button @click.prevent="validateForm" id="submitbutton"> <p>  Verstuur contactformulier </p> </button>

    <p v-if="errors" class="error error-global">Het formulier is niet correct ingevuld,
      <br> zie bovenstaande foutmelding(en) en verzend opnieuw.
    </p>
    <p v-else-if="empty === 'submit clicked'" class="error">Het formulier is leeg
    </p>

    <p class="conformation" v-if="formState === 'isSending'">Wordt verzonden...</p>
    <p class="conformation" v-if="formState === 'emailSend'">Verzonden</p>

  </form>
  </div>
  </div>
</template>

<script>
import axios from 'axios';
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";

export default {
  name: 'contact',
  components: {
  },

  data() {
    return {
      formState: null, 
      errors: false,
      empty: true,
      formResponses: {
        name: null,
        number: null,
        email: null,
        project: null,
        checkbox: false
      },
    }
  },

  validations: {
    formResponses: {
      name: {
        required,
        minLength: minLength(2)
      },
      number: {
        required,
        minLength: minLength(2)
      },
      email: {
        required,
        email
      },
      project: {
        required,
        minLength: minLength(2)
      },
      checkbox:{
      sameAs: sameAs(() => true)
      }
    }
 },
  
  methods: {

    async sendForm () {
      this.formState = 'isSending';

      try {
        await axios.post('https://us-central1-folded-paper-corporate-website.cloudfunctions.net/sendMail',{ 
          name: this.formResponses.name,
          number: this.formResponses.number,
          email: this.formResponses.email,
          project: this.formResponses.project

        });

        this.formState = 'emailSend';

        setTimeout(() => this.formState = null, 5000);
      } catch (error) {
        console.error(error)
      }
    },
    
    validateForm() {
      this.$v.$touch()
      this.empty = !this.$v.formResponses.$anyDirty;
      this.errors = this.$v.formResponses.$anyError;
      if (this.errors === false && this.empty === false) {
        //this is where you send the responses
        this.sendForm();
      }
    },

    checkform: function(){
    var f = document.forms["theformTwo"].elements;
    var cansubmit = true;

    for (var i = 0; i < f.length; i++) {
      if (f[i].value.length == 0) cansubmit = false;
    }

    if (cansubmit) {
      document.getElementById('submitbutton').disabled = !cansubmit;
    }
  },

  checkInputName: function(){
		  if (document.querySelector(".name").value == '') {
      document.querySelector(".labelName").classList.remove("activelabelName");
      document.querySelector(".name").classList.remove("border-color-yellow");

			} else {
      document.querySelector(".labelName").classList.add("activelabelName");
      document.querySelector(".name").classList.add("border-color-yellow");
	  }	
  },

  checkInputProject: function(){
		  if (document.querySelector(".project").value == '') {
      document.querySelector(".labelProject").classList.remove("activelabelProject");
      document.querySelector(".project").classList.remove("border-color-yellow");

			} else {
      document.querySelector(".labelProject").classList.add("activelabelProject");
      document.querySelector(".project").classList.add("border-color-yellow");
	  }	
  },

  checkInputNumber: function(){
		  if (document.querySelector(".number").value == '') {
      document.querySelector(".labelNumber").classList.remove("activelabelNumber");
      document.querySelector(".number").classList.remove("border-color-yellow");

			} else {
      document.querySelector(".labelNumber").classList.add("activelabelNumber");
      document.querySelector(".number").classList.add("border-color-yellow");
	  }	
  },

  checkInputEmail: function(){
	  if (document.querySelector(".email").value == '') {
    document.querySelector(".labelEmail").classList.remove("activelabelEmail");
    document.querySelector(".email").classList.remove("border-color-yellow");

		} else {
    document.querySelector(".labelEmail").classList.add("activelabelEmail");
    document.querySelector(".email").classList.add("border-color-yellow");
	  }	
  },
  },
}

</script>

<style lang="scss" scoped>

.error {
  color: red;
  min-height: 32px;
}
.error-global {
  padding-top: 16px;
  text-align: center;
}

.conformation {
  background: $yellow;
  padding: 8px;
  text-align: center;
  color: $white;
}

  #submitbutton{
    padding: 12px 24px;
    position: relative;
    display: table;
    border-radius: 50px;
    margin: 0 auto;
    cursor: pointer;
    color: $black;
    background-color: $white;
    border: 1px dashed $yellow;
    @include transition;
    margin: 0 auto;
    display: block;
    margin-bottom: layout-val-64(.5);
        
      p {
        margin: 0;
      }
  }

.checkbox-group{
  margin-bottom: 15px;
  width: 100%;
  max-width: 620px;
  margin: 0 auto;
  position:relative;

    label{
      padding-left: 8px;
    }
    p{
      color:red;
    }
}

.form-group {
  margin-bottom: 15px;
  width: 100%;
  max-width: 620px;
  margin: 0 auto;
  position:relative;
  
  input, select, textarea{
    height: 55px;
    width: 100%;
    margin: 8px auto;
    display: block;
  }

  textarea{
    height: 150px;
    padding: layout-val-8(2);
    resize: none;
  }

  label {
    transition: all 0.3s ease;
    @include pos-center($axis: 'both');
    top:64px;
    text-align: center;
    display: block;
    pointer-events:none;
  }

  input, select, textarea {
    transition: all 0.3s ease;
    border: 1px solid #eeeeee;
    display: block;
    width: 100%;
    text-align:center;
    font-family: 'futura-pt', sans-serif;

    &:focus {
      outline: none;
      border: 1px solid #cccccc;
    }
  }

  .form-control {
    border-color: $yellow;
    @include transition;
  }

  .activelabelName, .activelabelEmail, .activelabelProject, .activelabelBudget, .activelabelNumber {
    transition: all 0.3s ease;
    color: $grey;
    top:8px;
    left:0;
    transform: none;
  }
}

.border-color-yellow{
  border-color: $yellow !important;
}
  .form-control {
    border-color: $yellow !important;
    @include transition;
  }
</style>
